import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { authApi, setToken, setUser } from "../lib/authApi";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await authApi.post("/auth/google/session", { session_id: sessionId });
        setToken(data.access_token);
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}!`);
        navigate(data.user.role === "admin" ? "/admin" : "/portal", { replace: true });
      } catch {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/portal/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin text-primary" strokeWidth={1.5} />
    </div>
  );
}
